import {HTMLAttributes, useEffect, useState} from 'react';
import {AdfitScript} from '../../../common/containers/DisplayAdContainer/AdfitScript';
import {useHasMounted} from '../../../common/shared/hooks/useHasMounted';
import {
  DisplayAd as DisplayAdInterface,
  Maybe,
} from '../../../graphql/generated/types';
import {DisplayAd} from './DisplayAd';
import {DisplayAdType} from './DisplayAdType.enum';

export function AdfitLoader({
  displayAd,
  type,
  isWebView,
  ...props
}: HTMLAttributes<HTMLDivElement> & {
  displayAd?: Maybe<DisplayAdInterface>;
  type?: DisplayAdType;
  isWebView?: boolean;
}) {
  const noAdHandler = `onNoAd-${displayAd?.sectionUid || 0}`;
  const [showFallback, setShowFallback] = useState(false);

  useEffect(() => {
    (window as {[key: string]: any})[noAdHandler] = () => {
      // 보통 광고 물량이 부족할 때 no ad 가 뜸
      setShowFallback(true);
    };

    window.adfit?.();

    return () => {
      if (!noAdHandler) {
        return;
      }
      if ((window as {[key: string]: any})[noAdHandler]) {
        delete (window as {[key: string]: any})[noAdHandler];
      }
    };
  }, [noAdHandler]);

  const didMounted = useHasMounted();
  if (!displayAd?.momentUid) {
    if (didMounted) {
      throw new Error('momentUid 가 undefined 입니다');
    } else {
      return null;
    }
  }
  return (
    <>
      <AdfitScript />
      <DisplayAd
        showFallback={showFallback}
        type={type}
        displayAd={displayAd}
        isWebView={isWebView}
        noAdHandler={noAdHandler}
        {...props}
      />
    </>
  );
}
